import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import useFormValidator from 'useFormValidator';
import { connect } from 'react-redux';
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import * as actions from '../action';
import * as c from '../constant';

function DateTransmittalModal({
  type
}) {
  const [formData, setFormData] = useState({
    date_start: '',
    date_end: '',
  });
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const validateForm = useFormValidator(formData, {
    bpls_batch_number: 'required|number',
  });
  const setModal = useContext(ModalContext);

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  // eslint-disable-next-line consistent-return
  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    const args = {
      ...formData,
      start_date: `${moment(_.get(formData, 'date_start')).format(
        'DD-MM-YYYY')}`,
      end_date: `${moment(_.get(formData, 'date_end')).format(
        'DD-MM-YYYY')}`,
    };

    const src = `${process.env.REACT_APP_WS}${c.BPLS_TRANSMITTAL}?bearer_token=${token}
    )}&date_start=${args.start_date}&date_end=${args.end_date}&email=${_.get(
      authProfile,
      'email'
    )}&type=${type}`;

    setTimeout(() => {
      window.location.href = src;
    }, 100);
    setModal({ isOpen: false });

  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="form-input-group col-12 col-md-12">
            <label>Start Date:</label>
            <DateInputPicker
              required
              className="full-input"
              onChange={handleOnChangeDate('date_start')}
              value={_.get(formData, 'date_start')}
              maxDate={new Date()}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-input-group col-12 col-md-12">
            <label>End Date:</label>
            <DateInputPicker
              required
              className="full-input"
              onChange={handleOnChangeDate('date_end')}
              value={_.get(formData, 'date_end')}
              maxDate={new Date()}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              Print
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

DateTransmittalModal.propTypes = {
  type: PropTypes.string,
};

DateTransmittalModal.defaultProps = {
  type: '',
};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(DateTransmittalModal);
